import { config } from '../config';

/**
 * Reports browser errors to PayRight's project in the platform's self-hosted
 * GlitchTip. The API says whether reporting is on and where to (a Sentry DSN
 * only permits sending events), so nothing is baked into the bundle and an
 * unconfigured environment sends nothing. Reports carry no user, query
 * strings or breadcrumbs. The SDK is loaded only when reporting is on.
 */
export const clientConfigUrl = (graphqlUrl = config.graphqlUrl) => graphqlUrl.replace(/\/graphql\/?$/, '/client-config');

export async function startErrorTracking(load: typeof fetch = fetch) {
  try {
    const response = await load(clientConfigUrl());
    if (!response.ok) return false;
    const body = await response.json() as { errorTracking?: { dsn: string; environment: string } | null };
    if (!body.errorTracking?.dsn) return false;
    const Sentry = await import('./sentry');
    Sentry.init({
      dsn: body.errorTracking.dsn,
      environment: body.errorTracking.environment,
      sendDefaultPii: false,
      initialScope: { tags: { service: 'web' } },
      beforeBreadcrumb: () => null,
      beforeSend: event => {
        delete event.user;
        if (event.request?.url) event.request = { url: event.request.url.split(/[?#]/)[0]! };
        return event;
      },
    });
    return true;
  } catch {
    // Error reporting must never stop the application from loading.
    return false;
  }
}
